// extracted by mini-css-extract-plugin
export default {"wrapper":"accountSetupWizardBreadcrumb_wrapper__3A8T5","selected":"accountSetupWizardBreadcrumb_selected__QeaVp"};